export var HANA_AMPLITUDE = {
  RENDER_HOME: 'Render Panel Hana',
  RENDER_CHAT: 'Render Panel Chat',
  RENDER_DRAWER: 'Render Panel Drawer',
  PROMPT_SUBMIT: 'Click Prompt',
  FEEDBACK_TYPE: 'Click Valorar Respuesta',
  FEEDBACK_SENT: 'Send Feedback ',
  ERROR_OCURRED: 'Hana - Error Message',
  MESSAGE_COPIED: 'Hana - Copy Message',
  ANOTHER_ANSWER: 'Hana - Another Answer',
  REFRESH_PROMPTS: 'Hana - Refresh Prompts',
  CATEGORY_SELECTED: 'Hana - Select Category',
  REPORT_DOWNLOAD: 'Hana - Report Download',
  //* Post-MVP
  DATA_INSERTED: 'Hana - Insertar Data',
  DELETE_CONVERSATION: 'Hana - Delete Conversation',
  PREVIUS_CONVERSATION: 'Hana - Previous Conversation',
  PIN_CONVERSATION: 'Hana - Pin Conversation',
  CHANGE_CONVERSATION: 'Hana - Change Name Conversation',
  DASHLET_HANA: 'Banner Hana - Learning Dashboard Clicked',
  PROMPT_SUGGESTION: 'Hana - Prompt Suggestion'
};